import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UsersObject } from '@trendbuild/trend-agendor-api/src/lib/models/users.types';
import { AbstractComponent, AgendorIntegration, Company, Integration, IntegrationService, IntegrationTypeEnum } from 'lib-trend-core';
import { takeUntil } from 'rxjs';

@Component({
    selector: 'app-agendor-integration-form',
    templateUrl: './agendor-integration-form.v2.component.html',
    // templateUrl: './agendor-integration-form.component.html',
    styleUrls: ['./agendor-integration-form.v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AgendorFormComponent extends AbstractComponent implements OnInit {
  integration: Integration;
  hideAllPasswords: boolean = true;
  apiToken: string;
  userCurrent: UsersObject;


  breadcrumb = [
    { href: '/integrations', label: 'integrations.breadcrumb.integrations' },
    { href: '/integrations/agendor/list', label: 'integrations.breadcrumb.agendor' },
    { label: '' },
  ]

  constructor(
    injector: Injector,
    private integrationService: IntegrationService
  ) {
    super(injector)
    this.integration = <Integration>{
      type: IntegrationTypeEnum.AGENDOR,
      actived: true,
      removed: false,
      metadata: <AgendorIntegration>{},
      company: <Company>{},
    }
    this.setupForm()
  }

  ngOnInit() {
    this.loadingContent = true;
    this.isNew = true;
    const id = this.getParam('id');

    if (!!id) {
      this.isNew = false;
      this.getIntegrationById(id);
    } else {
      this.loadingContent = false;
    }

    if (!this.isNew) {
      this.breadcrumb[2].label = 'Editar Integração';
    } else {
      this.breadcrumb[2].label = 'Adicionar Integração';
    }
  }

  setupForm() {
    this.formGroup = new FormGroup({
      name: new FormControl('', [Validators.required]),
      metadata: new FormGroup({
        token: new FormControl('', [Validators.required]),
      }),
    });

    this.formGroup.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        this.integration = Object.assign(this.integration, value);
      });
  }

  getIntegrationById(idIntegration: string) {
    this.integrationService
      .getById(idIntegration)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (integration: Integration) => {
          this.integration = integration;
          this.formGroup.patchValue(this.integration);
          this.loadingContent = false;
        },
        error: (err) => {
          this.alertService.error(err.error.message);
          this.loadingContent = false;
        },
      });
  }

  async onSubmit() {
    if (!this.formGroup.valid) {
      this.validateAllFormFields(this.formGroup);
      return;
    }

    this.loading = true;

    if (this.isNew) {
      const currentCompany = this.getCompanyCurrentUser();
      if (currentCompany) {
        this.integration.company = currentCompany;
      }

      const token = this.integration.metadata['token'];

      this.integrationService.getAgendorUsers(token).pipe(
        takeUntil(this.destroy$)
      ).subscribe({
        next: (userCurrent) => {
          if (!userCurrent.data) {
            this.alertService.error(this.t('integrations.agendorForm.errorInvalidToken'));
            this.loading = false;
            return;
          }

          this.userCurrent = userCurrent.data;

          this.integrationService.create(this.integration).pipe(
            takeUntil(this.destroy$)
          ).subscribe({
            next: () => {
              this.alertService.success(this.t('integrations.agendorForm.successCreated'));
              this.goBack();
            },
            error: (err) => {
              this.alertService.error(err.error?.message || this.t('integrations.agendorForm.errorCreate'));
            },
            complete: () => {
              this.loading = false;
            }
          });
        },
        error: (err) => {
          this.alertService.error(err.error?.message || this.t('integrations.agendorForm.errorValidateToken'));
          this.loading = false;
        }
      });

    } else {
      const token = this.integration.metadata['token'];

      this.integrationService.getAgendorUsers(token).pipe(
        takeUntil(this.destroy$)
      ).subscribe({
        next: (userCurrent) => {
          if (!userCurrent.data) {
            this.alertService.error(this.t('integrations.agendorForm.errorInvalidToken'));
            this.loading = false;
            return;
          }

          this.userCurrent = userCurrent.data;

          this.integrationService.update(this.integration._id, this.integration).pipe(
            takeUntil(this.destroy$)
          ).subscribe({
            next: () => {
              this.alertService.success(this.t('integrations.agendorForm.successUpdated'));
              this.goBack();
            },
            error: (err) => {
              this.alertService.error(err.error?.message || this.t('integrations.agendorForm.errorUpdate'));
            },
            complete: () => {
              this.loading = false;
            }
          });
        },
        error: (err) => {
          this.alertService.error(err.error?.message || this.t('integrations.agendorForm.errorValidateToken'));
          this.loading = false;
        }
      });
    }
  }

  togglePasswordVisibility(): void {
    this.hideAllPasswords = !this.hideAllPasswords;
  }

  cancel() {
    this.router.navigate(['/integrations/agendor/list']);
  }
}
